import { formatCurrency } from "util/format";
import {
  UpCircleOutlined,
  DownCircleOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";

export const ColumnsMonthCashFlow = [
  {
    title: "Cliente",
    dataIndex: "client",
    textWrap: "word-break",
    ellipsis: true,
  },
];
export const ColumnsMonthCashFlowExpend = (data) => {
  let months = replaceMonth(data);
  let width = "14%";

  switch (months.length) {
    case 4:
      width = "13%";
      break;
    case 5:
      width = "10%";
      break;
    case 6:
      width = "7%";
      break;
    case 7:
      width = "6%";
      break;
    case 8:
      width = "5%";
      break;
    case 9:
      width = "5%";
      break;
    case 10:
      width = "5%";
      break;
    case 11:
      width = "5%";
      break;
    case 12:
      width = "4%";
      break;
    default:
      break;
  }
  const columns = [];
  columns.push({
    title: <div style={{ textAlign: "center" }}>Grupo</div>,
    dataIndex: "name",
    textWrap: "word-break",
    ellipsis: true,
    width: width,
    fixed: "left",
    responsive: ["sm"],
    render(text, record) {
      let color = record.isDad ? "#BABBC2" : "";
      let margin = record.isDad ? "0px" : "10px";
      let fontWeight = record.isDad ? "bold" : "initial";
      if (record.categoryType == "REVENUE") {
        if (record.isDad) {
          color = "#BABBC2";
        }
      } else {
        if (record.isDad) {
          color = "#BABBC2";
        }
      }
      if (record.mapping && record.mapping.length == 0) {
        color = "#98A5AC";
      }
      if (record.order == 0 || record.order == 9999) {
        color = "#98A5AC";
      }
      let func = record.isDad ? () => {} : record.showDetails;

      return {
        props: {
          style: { background: color },
        },
        children: (
          <div
            style={{
              marginLeft: margin,
              fontWeight: fontWeight,
              cursor: "pointer",
            }}
            onClick={() => func("total", record, "Total")}
          >
            {text}
          </div>
        ),
      };
    },
  });

  if (months) {
    months.forEach((element) => {
      columns.push({
        title: <div style={{ textAlign: "center" }}>{element.name}</div>,
        children: [
          {
            title: <div style={{ textAlign: "center" }}>Realizado</div>,
            dataIndex: "amount",
            textWrap: "word-break",
            ellipsis: true,
            responsive: ["sm"],
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.profit;
                }
              });
              let color = record.isDad ? "#BABBC2" : "";
              let fontWeight = record.isDad ? "bold" : "initial";
              if (record.categoryType == "REVENUE" && record.isDad) {
                color = "#BABBC2";
              } else if (record.categoryType == "EXPENSE" && record.isDad) {
                color = "#BABBC2";
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              let func = record.isDad ? () => {} : record.showDetails;

              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      func(getKeyMonth(element.name), record, element.name)
                    }
                  >
                    {formatCurrency(value)}
                  </div>
                ),
              };
            },
          },
          {
            title: <div style={{ textAlign: "center" }}>Orçado</div>,
            dataIndex: "budget",
            textWrap: "word-break",
            ellipsis: true,
            responsive: ["sm"],
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.budget;
                }
              });
              let color = record.isDad ? "#BABBC2" : "";
              let fontWeight = record.isDad ? "bold" : "initial";
              if (record.categoryType == "REVENUE" && record.isDad) {
                color = "#BABBC2";
              } else if (record.categoryType == "EXPENSE" && record.isDad) {
                color = "#BABBC2";
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                  >
                    {formatCurrency(value)}
                  </div>
                ),
              };
            },
          },
          {
            title: <div style={{ textAlign: "center" }}>Desvio</div>,
            dataIndex: "profit",
            textWrap: "word-break",
            ellipsis: true,
            responsive: ["sm"],
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key && item.profitBudget != null) {
                  value = item.profitBudget;
                }
              });
              let color = record.isDad ? "#BABBC2" : "";
              let fontWeight = record.isDad ? "bold" : "initial";
              let colorIcon = "yellow";
              let icon = <RightCircleOutlined />;
              if (record.categoryType == "EXPENSE") {
                if (value > 0 && value < 100) {
                  colorIcon = "green";
                  icon = <UpCircleOutlined />;
                } else if (value > 100) {
                  colorIcon = "red";
                  icon = <DownCircleOutlined />;
                } else if (value < 0) {
                  colorIcon = "red";
                  icon = <DownCircleOutlined />;
                }
              } else {
                if (value > 100) {
                  colorIcon = "green";
                  icon = <UpCircleOutlined />;
                } else if (value < 100) {
                  colorIcon = "red";
                  icon = <DownCircleOutlined />;
                }
              }
              if (record.categoryType == "REVENUE" && record.isDad) {
                color = "#BABBC2";
              } else if (record.categoryType == "EXPENSE" && record.isDad) {
                color = "#BABBC2";
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                  >
                    {value + "%"}{" "}
                    <span style={{ color: colorIcon }}>{icon}</span>
                  </div>
                ),
              };
            },
          },
        ],
      });
    });
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Total</div>,

    children: [
      {
        title: <div style={{ textAlign: "center" }}>Realizado</div>,
        dataIndex: "amount",
        responsive: ["sm"],
        textWrap: "word-break",
        ellipsis: true,
        render(text, record) {
          let color = record.isDad ? "#BABBC2" : "";
          let fontWeight = record.isDad ? "bold" : "initial";
          if (record.categoryType == "REVENUE" && record.isDad) {
            color = "#BABBC2";
          } else if (record.categoryType == "EXPENSE" && record.isDad) {
            color = "#BABBC2";
          }
          if (record.mapping && record.mapping.length == 0) {
            color = "#98A5AC";
          }
          if (record.order == 0 || record.order == 9999) {
            color = "#98A5AC";
          }
          let func = record.isDad ? () => {} : record.showDetails;

          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
                onClick={() => func("total", record, "Total")}
              >
                {formatCurrency(text)}
              </div>
            ),
          };
        },
      },
      {
        title: <div style={{ textAlign: "center" }}>Orçado</div>,
        dataIndex: "budget",
        responsive: ["sm"],
        textWrap: "word-break",
        ellipsis: true,
        render(text, record) {
          let color = record.isDad ? "#BABBC2" : "";
          let fontWeight = record.isDad ? "bold" : "initial";
          if (record.categoryType == "REVENUE" && record.isDad) {
            color = "#BABBC2";
          } else if (record.categoryType == "EXPENSE" && record.isDad) {
            color = "#BABBC2";
          }
          if (record.mapping && record.mapping.length == 0) {
            color = "#98A5AC";
          }
          if (record.order == 0 || record.order == 9999) {
            color = "#98A5AC";
          }
          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
              >
                {formatCurrency(text)}
              </div>
            ),
          };
        },
      },
      {
        title: <div style={{ textAlign: "center" }}>Desvio</div>,
        dataIndex: "profit",
        responsive: ["sm"],
        textWrap: "word-break",
        ellipsis: true,
        render(text, record) {
          let color = record.isDad ? "#BABBC2" : "";
          let fontWeight = record.isDad ? "bold" : "initial";
          let colorIcon = "yellow";
          let icon = <RightCircleOutlined />;
          if (record.categoryType == "EXPENSE") {
            if (text > 0 && text < 100) {
              colorIcon = "green";
              icon = <UpCircleOutlined />;
            } else if (text > 100) {
              colorIcon = "red";
              icon = <DownCircleOutlined />;
            } else if (text < 0) {
              colorIcon = "red";
              icon = <DownCircleOutlined />;
            }
          } else {
            if (text > 100) {
              colorIcon = "green";
              icon = <UpCircleOutlined />;
            } else if (text < 100) {
              colorIcon = "red";
              icon = <DownCircleOutlined />;
            }
          }
          if (record.categoryType == "REVENUE" && record.isDad) {
            color = "#BABBC2";
          } else if (record.categoryType == "EXPENSE" && record.isDad) {
            color = "#BABBC2";
          }
          if (record.mapping && record.mapping.length == 0) {
            color = "#98A5AC";
          }
          if (record.order == 0 || record.order == 9999) {
            color = "#98A5AC";
          }
          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
              >
                {text + "% "} <span style={{ color: colorIcon }}>{icon}</span>
              </div>
            ),
          };
        },
      },
    ],
  });

  return columns;
};
export const ColumnsMonthCashFlowCategoryExpend = [
  {
    title: "Categoria",
    dataIndex: "category",
    width: "20%",
    responsive: ["sm"],

    render: (text) => {
      return <div style={{ marginLeft: "40px" }}>{text}</div>;
    },
  },
  {
    title: "Realizado",
    dataIndex: "amount",
    responsive: ["sm"],

    render: (text) => {
      return <div>{formatCurrency(text)}</div>;
    },
  },
  {
    title: "Orçado",
    dataIndex: "budget",
    responsive: ["sm"],

    render: (text) => {
      return <div>{formatCurrency(text)}</div>;
    },
  },
  {
    title: "Desvio",
    dataIndex: "profit",
    responsive: ["sm"],

    render: (text) => {
      return <div>{text + "%"}</div>;
    },
  },
];

export const ColumnsCategoryDataCompetence = [
  {
    title: "Data",
    dataIndex: "competence",
    render: (text) => {
      let dateString = moment(text).format("DD/MM/YYYY");
      return dateString;
    },
  },
  {
    title: "Cliente",
    dataIndex: "customer",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Tipo",
    dataIndex: "type",
  },
  {
    title: "Valor",
    dataIndex: "amount",
    render: (text) => {
      return formatCurrency(text);
    },
  },
];

export const ColumnsCategoryDataDueDateCompetence = [
  {
    title: "Data",
    dataIndex: "dueDate",
    render: (text) => {
      let dateString = moment(text).format("DD/MM/YYYY");
      return dateString;
    },
  },
  {
    title: "Cliente",
    dataIndex: "customer",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Tipo",
    dataIndex: "type",
  },
  {
    title: "Valor",
    dataIndex: "amount",
    render: (text) => {
      return formatCurrency(text);
    },
  },
];

export const ColumnsCategoryDataDueDate = [
  {
    title: "Data",
    dataIndex: "dueDate",
    render: (text) => {
      let dateString = moment(text).format("DD/MM/YYYY");
      return dateString;
    },
  },
  {
    title: "Cliente",
    dataIndex: "customer",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Tipo",
    dataIndex: "type",
  },
  {
    title: "Valor",
    dataIndex: "amountPaid",
    render: (text) => {
      return formatCurrency(text);
    },
  },
];
function replaceMonth(month) {
  const newMonth = [];
  if (month) {
    month.forEach((monthItem) => {
      var name = monthItem.trim();
      name = name.replace("JANUARY", "Janeiro");
      name = name.replace("FEBRUARY", "Fevereiro");
      name = name.replace("MARCH", "Março");
      name = name.replace("APRIL", "Abril");
      name = name.replace("MAY", "Maio");
      name = name.replace("JUNE", "Junho");
      name = name.replace("JULY", "Julho");
      name = name.replace("AUGUST", "Agosto");
      name = name.replace("SEPTEMBER", "Setembro");
      name = name.replace("OCTOBER", "Outubro");
      name = name.replace("NOVEMBER", "Novembro");
      name = name.replace("DECEMBER", "Dezembro");
      let order = 0;
      switch (name) {
        case "Janeiro":
          order = 1;
          break;
        case "Fevereiro":
          order = 2;
          break;
        case "Março":
          order = 3;
          break;
        case "Abril":
          order = 4;
          break;
        case "Maio":
          order = 5;
          break;
        case "Junho":
          order = 6;
          break;
        case "Julho":
          order = 7;
          break;
        case "Agosto":
          order = 8;
          break;
        case "Setembro":
          order = 9;
          break;
        case "Outubro":
          order = 10;
          break;
        case "Novembro":
          order = 11;
          break;
        case "Dezembro":
          order = 12;
          break;

        default:
          break;
      }
      newMonth.push({
        name: name,
        order: order,
        key: monthItem.substring(0, 3),
      });
    });
  }
  let monthOrder = newMonth.sort(compareNumbers);

  return monthOrder;
}

function compareNumbers(a, b) {
  return a.order - b.order;
}

function getKeyMonth(month) {
  let key = 0;
  switch (month) {
    case "Janeiro":
      key = "01";
      break;
    case "Fevereiro":
      key = "02";
      break;
    case "Março":
      key = "03";
      break;
    case "Abril":
      key = "04";
      break;
    case "Maio":
      key = "05";
      break;
    case "Junho":
      key = "06";
      break;
    case "Julho":
      key = "07";
      break;
    case "Agosto":
      key = "08";
      break;
    case "Setembro":
      key = "09";
      break;
    case "Outubro":
      key = "10";
      break;
    case "Novembro":
      key = "11";
      break;
    case "Dezembro":
      key = "12";
      break;

    default:
      key = "total";
      break;
  }

  return key;
}
